window.theme = window.theme || {};

$(document).ready(function () {
  // TOOLTIP SCRIPS
  // If you click anywhere outside the tooltip, close the tooltip
  $("body").on("click", function (event) {
    if (!$(event.target).closest(".tooltip").length) {
      $(".tooltip__content").removeClass("tooltip__content--visible tooltip__content--visible-locked");
    }
  });

  // When you hover the tooltip, add open state; if you hover or click, ensure it stays on screen
  $("body").on("click mouseenter focusin", ".tooltip", function (event) {
    $(this).children(".tooltip__content").addClass("tooltip__content--visible");

    // Ensure the tooltip stays on the screen
    if ($(this).children(".tooltip__content").offset().left < 0) {
      $(this).children(".tooltip__content").offset({ left: 15 });
    }
  });

  // Once your mouse leaves, remove open for hover
  $("body").on("mouseleave focusin", ".tooltip", function (event) {
    if (event.relatedTarget || event.toElement) {
      // do whatever
      $(this).children(".tooltip__content").removeClass("tooltip__content--visible");
    }
  });

  // When you click the tooltip, toggle the open state
  $("body").on("click", ".tooltip", function (event) {
    $(this).children(".tooltip__content").toggleClass("tooltip__content--visible-locked");
  });

  // END TOOLTIP SCRIPTS

  $("body").on("click", ".swatch-image", function () {
    var selectedColor = $(this).data("value"),
      detailsContainer = $(this).parents(".product-list-item-details");

    if (!detailsContainer.find('.meta--custom[data-color="' + selectedColor + '"]').hasClass("active")) {
      detailsContainer.find(".meta--custom").removeClass("active");
      detailsContainer.find('.meta--custom[data-color="' + selectedColor + '"]').addClass("active");
    }
  });

  $(".filter-menu__container-close-btn").on("click", function (e) {
    e.preventDefault();
    if ($("#pt-nav-toggle").length) {
      $("#pt-nav-toggle").trigger("click");
    }
  });

  if ($("#collectionContainer .pagination").length && $(".sidebar").length) {
    $(".sidebar").addClass("has-pagination");
  }

  /*
  if ($(".template-product").length) {
    var reviewFormLoaded = setInterval(function () {
      if (
        $("#BVRRContainer .bv-section-summary-table").length &&
        $("#BVRRContainer .bv-content-list-reviews").length &&
        $("#BVRRSearchContainer .bv-rating-ratio-count .bv-rating-label").length
      ) {
        clearInterval(reviewFormLoaded);
        $("#BVRRContainer .bv-secondary-rating-summary.bv-section-summary-block")
          .clone()
          .appendTo($(".product-reviews__list .bv-section-summary-inline"));
        $(".bv-core-container-57").addClass($("#BVRRContainer .bv-cv2-cleanslate > div").attr("class"));

        $("#BVRRSearchContainer .bv-rating-ratio-count .bv-rating-label .bv-off-screen").remove();
        var reviewsCaption = $("#BVRRSearchContainer .bv-rating-ratio-count .bv-rating-label")
          .text()
          .replace(/ Review(s?)/, "");
        $(".product-reviews__summary").text("Reviews (" + reviewsCaption + ")");

        var $reviewCounts = 0;

        $("#BVRRContainer .bv-content-list-reviews")
          .find(".bv-content-review")
          .each(function () {
            $reviewCounts++;
            $(this).clone().appendTo($(".product-reviews__list .bv-content-list-reviews"));
          });

        if ($reviewCounts <= 4) {
          $(".button--reviews--more").remove();
        }

        $(".product-page__accordion--reviews").addClass("accordion");
      } else {
        if ($("#BVRRContainer .bv-rating-none").length) {
          clearInterval(reviewFormLoaded);
          $(".product-reviews__summary").text("Reviews (0)");
          $(".button--reviews--more").remove();
          $(".product-page__accordion--reviews").addClass("accordion");
          $(".product-reviews__list").remove();
        }
      }
      // if ($('.spr-form').length && $('.product-page__product-details:not(.product-page__product-details--mobile) .product-page__reviews-wrapper .spr-badge-caption').length && $('.modal--product-reviews .spr-content .spr-reviews').length && $('.product__reviews-form').length) {
      //   clearInterval(reviewFormLoaded);
      //   $('.product-page__product-details:not(.product-page__product-details--mobile) .product-page__reviews-wrapper .spr-badge-starrating').clone().appendTo($('.product-reviews__rating'));
      //   $('.spr-form').appendTo($('.product__reviews-form'));

      //   if ($('.product-page__product-details:not(.product-page__product-details--mobile) .product-page__reviews-wrapper .spr-badge-caption').text() == 'No reviews') {
      //     var reviewsCaption = '0';
      //     $('.product-reviews__summary').text("Reviews ("+reviewsCaption+")");
      //     $('.product-page__accordion--reviews').addClass('accordion');
      //     $('.button--reviews--more, .product-reviews__list').remove();
      //   } else {
      //     var reviewsCaption = $('.product-page__product-details:not(.product-page__product-details--mobile) .product-page__reviews-wrapper .spr-badge-caption').text().replace(/ review(s?)/, "");
      //     $('.product-reviews__summary').text("Reviews ("+reviewsCaption+")");

      //     var reviewsLoaded = setInterval(function(){
      //       if ($('.modal--product-reviews .spr-content .spr-reviews').children().length) {
      //         clearInterval(reviewsLoaded);

      //         if(!$('.modal--product-reviews .spr-pagination').length) {
      //           $('.button--reviews--more').remove();
      //         }

      //         $('.spr-content .spr-reviews').children().clone().appendTo($('.product-reviews__list'));
      //         $('.product-page__accordion--reviews').addClass('accordion');
      //       }
      //     }, 1000)
      //   }

      // }
    }, 1000); // check every 100ms

    $(".button--reviews--form").on("click", function (e) {
      e.preventDefault();
      $("#BVRRContainer .bv-submission-button").trigger("click");
    });
  }
  */

  $("body").on("click", ".blog-posts__load-more", function (e) {
    e.preventDefault();

    var nextUrl = $(this).attr("href");
    $.ajax({
      url: nextUrl,
      type: "GET",
      success: function (data) {
        $(".blog-posts__list").append($(data).find(".blog-posts__list").html());
        $(".blog-posts__load-more-container").html($(data).find(".blog-posts__load-more-container").html());
      },
    });
  });

  var $sliderCollectionsOptions = {
    pageDots: false,
    wrapAround: true,
    adaptiveHeight: true,
  };

  // // enable prev/next buttons at 768px
  // if ( matchMedia('screen and (max-width: 767px)').matches ) {
  //     $sliderCollectionsOptions.wrapAround = true;
  // }

  // enable prev/next buttons at 768px
  if (matchMedia("screen and (min-width: 767px)").matches) {
    $sliderCollectionsOptions.contain = true;
    $sliderCollectionsOptions.groupCells = true;
  }

  setTimeout(function () {
    $(".slider--collections").flickity($sliderCollectionsOptions);
  }, 1000);

  // $('.slider--real-looks').on( 'ready.flickity', function() {
  //   console.log('Flickity ready');
  //   $('.slider--real-looks').find('.slide-item').css('height', '100%');
  // });
  $(".slider--real-looks").flickity($sliderCollectionsOptions);

  var $sliderCategoryOptions = {
    pageDots: false,
    wrapAround: true,
    adaptiveHeight: true,
  };

  var loopBool = $(".slider--category").data("loop");

  // enable prev/next buttons at 768px
  if (matchMedia("screen and (min-width: 767px)").matches) {
    $sliderCategoryOptions.contain = true;
    $sliderCategoryOptions.groupCells = true;
    $sliderCategoryOptions.wrapAround = loopBool;
  }

  $(".slider--category").flickity($sliderCategoryOptions);

  var relatedProductsLoaded = setInterval(function () {
    if ($(".home-module--collections-slider--related-products .product-list-item-price").length) {
      clearInterval(relatedProductsLoaded);
      $(".slider--related-products").addClass("active");
      $(".slider--related-products").flickity($sliderCollectionsOptions);
      $(".loading-gif--related-products").remove();
    }
  }, 5000); // check every 100ms

  $(".mobile_menu").slideMobileMenu({
    //Hamburger Id
    hamburgerId: "sm_menu_ham",
    //Menu Wrapper Class
    wrapperClass: "sm_menu_outer",
    //Submenu Class
    submenuClass: "submenu",
    //Menu Style
    menuStyle: "slide",
    onMenuLoad: function (menu) {
      console.log(menu);
      console.log("menu loaded");
    },
    onMenuToggle: function (menu, opened) {
      console.log(opened);
    },
  });

  $(".mobile-navigation-toggle--slide, .mobile-menu--slide__close-icon").on("click", function (e) {
    e.preventDefault();
    $("#sm_menu_ham").trigger("click");
  });

  // Constant elements
  const ACCORDION = ".accordion";
  const ACCORDION_BUTTON = ".accordion__title";

  // Constant trigger classes
  const OPEN_CLASS = "js-is-open";

  if ($(ACCORDION_BUTTON)) {
    $(ACCORDION_BUTTON).on("click", click);
    $(document).on("ready", initOpenFirstAccordions());
  }

  function click(event) {
    event.preventDefault();
    const $container = $(event.target).closest(ACCORDION);
    const isItemOpen = event.target.classList.contains(OPEN_CLASS);

    // Check for open sibling containers, and close them all (unless clicked item is open)
    if (!isItemOpen && $container.data("collapse-all").collapse) {
      collapseItems($container[0]);
    }

    // Toggle clicked container
    slideToggle(event.target);
  }

  function slideToggle(itemTitle) {
    const content = itemTitle.nextElementSibling;
    const item = itemTitle.parentElement;

    content.classList.toggle(OPEN_CLASS);
    item.classList.toggle(OPEN_CLASS);
    itemTitle.classList.toggle(OPEN_CLASS);
    changeHeight(content);
  }

  function initOpenFirstAccordions() {
    let accordions = document.getElementsByClassName("accordion--open-first");

    for (let i = 0; i < accordions.length; i++) {
      let content = accordions[i].children[0].querySelector(".accordion__title");
      slideToggle(content);
    }
  }

  function changeHeight(itemContent) {
    requestAnimationFrame(() => {
      itemContent.style.height = itemContent.classList.contains(OPEN_CLASS)
        ? itemContent.scrollHeight + "px"
        : 0;
    });
  }

  function collapseItems(accordion) {
    const itemList = accordion.children;
    for (let i = 0; i < itemList.length; i++) {
      // Don't toggle closed items
      if (itemList[i].classList.contains("js-is-open")) {
        slideToggle(itemList[i].querySelector(".accordion__title"));
      }
    }
  }
});

theme.Crisp = (function () {
  const cache = {
    collection_template: "__DO-NOT-SELECT__.products",
    search_template: "__DO-NOT-SELECT__",
  };

  const crispFilter = Crisp.Filter({
    filters: initFilter(),
  });

  function init() {
    return Crisp.SearchableCollection({
      handle: "all",
      searchTemplate: cache.search_template,
      collectionTemplate: cache.collection_template,
    });
  }

  function initFilter() {
    const array = [];
    const filters = document.querySelectorAll(".filter-menu .filter-group");
    if (filters.length <= 0) {
      return [{}];
    }

    filters.forEach((element) => {
      const groupName = element.dataset.collectionGroupTitle;
      if (groupName === undefined) {
        return;
      }

      const childrens = [];
      const collections = element.querySelectorAll(".collection-container");
      collections.forEach((item) => {
        childrens.push({
          name: item.querySelector("a").dataset.collection,
          filter: function (product) {
            return product.tags.indexOf(item.querySelector("a").dataset.collection) !== -1;
          },
        });
      });

      array.push({
        name: groupName,
        children: childrens,
      });
    });

    return array;
  }

  function deselectFilter(filter) {
    console.log("Deselect:", filter);
    crispFilter.deselect(filter);
  }

  function collectionSearch(searchableCollection, keyword, filter) {
    if (keyword) {
      setKeyword(searchableCollection, keyword);
    }

    if (filter) {
      selectCollectionFilter(searchableCollection, filter);
    }

    searchableCollection.setAnd(false);
    searchableCollection.setFields(["handle", "title", "tag", "variant"]);

    get(searchableCollection);
  }

  function selectCollectionFilter(searchableCollection, filter) {
    const arrayFilters = filter.split(",");
    arrayFilters.forEach((value) => {
      crispFilter.select(value);
      console.log("Select:", value);
    });

    console.log("Filters:", crispFilter);

    searchableCollection.setFilter(crispFilter.fn());
  }

  function setKeyword(searchableCollection, keyword) {
    searchableCollection.setQuery(keyword);
  }

  function get(searchableCollection) {
    const searchResult = document.querySelector("[data-js-result]");
    searchResult.style.display = "none";
    const loader = document.querySelector("[data-js-loader]");
    loader.style.display = "block";

    searchableCollection.getNext({
      number: 24,
      callback: function (response) {
        if (Crisp.isCancel(response.error)) {
          console.log("Crisp is Cancel");
          return;
        }

        // Handle error
        if (response.error) {
          console.log("Crisp Error", response.error);
          return;
        }

        searchResult.innerHTML = "";

        // console.log(response.payload);

        if (response.payload.length <= 0) {
          const p = document.createElement("p");
          p.classList.add("not-found");
          p.textContent =
            "No results found for this search. Please try again with different words, or try our filter.";
          searchResult.appendChild(p);
          loader.style.display = "none";
          searchResult.style.display = "block";
        } else {
          for (let i = 0; i < response.payload.length; i++) {
            searchResult.insertAdjacentHTML("beforeend", searchResultTemplate(response.payload[i]));
          }

          setTimeout(function () {
            searchResult.style.display = "block";
          }, 700);

          if (response.payload.length === 24) {
            setTimeout(function () {
              const loadMore = document.createElement("div");
              loadMore.setAttribute("id", "load-more");
              searchResult.appendChild(loadMore);
              infiniteScroll(searchableCollection);
            }, 1000);
          } else {
            loader.style.display = "none";
          }
        }
      },
    });
  }

  function infiniteScroll(searchableCollection) {
    var target = document.getElementById("load-more");

    var option = {
      root: null,
      rootMargin: "0px 0px 400px",
      threshold: [0],
    };

    var callback = function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          searchableCollection.getNext({
            number: 12,
            callback: function (response) {
              if (Crisp.isCancel(response.error)) {
                console.log("Crisp is Cancel");
                return;
              }

              // Handle error
              if (response.error) {
                console.log("Crisp Error", response.error);
                return;
              }

              // console.log('Payload:', response.payload);

              if (response.payload.length > 0) {
                const searchResult = document.querySelectorAll("[data-js-result]");

                for (let i = 0; i < response.payload.length; i++) {
                  searchResult[0].insertAdjacentHTML("beforeend", searchResultTemplate(response.payload[i]));
                }
                const loadMore = document.getElementById("load-more");
                searchResult[0].appendChild(loadMore);
              } else {
                const loadMore = document.getElementById("load-more");
                loadMore.parentNode.removeChild(loadMore);
                const loader = document.querySelector("[data-js-loader]");
                loader.style.display = "none";
              }
            },
          });
        }
      });
    };
    var observer = new IntersectionObserver(callback, option);
    observer.observe(target);
  }

  function searchResultTemplate(item) {
    let badge,
      price,
      withVariableUrl,
      rating = "";
    const brandLink = item.vendor
      ? `<p class="product-list-item-vendor vendor meta">${item.vendor}</p>`
      : `<p class="product-list-item-vendor vendor meta"><a href="${item.vendorLink}">${item.vendorTitle}</a></p>`;

    if (item.isSold) {
      badge = `<span class="product-list-item-badge inventory">${item.soldOutText}</span>`;
    }

    if (item.isSaleAndStock) {
      badge = `<span class="product-list-item-badge meta sale">${saleText}<br>${stockText}</span>`;
    }

    if (item.isStock) {
      badge = `<span class="product-list-item-badge meta inventory">${item.stockText}</span>`;
    }

    if (item.isSale) {
      badge = `<span class="product-list-item-badge meta sale">${item.saleText}</span>`;
    }

    if (badge === undefined) {
      badge = "";
    }

    if (item.reviews === "0") {
      for (let i = 0; i < 5; i++) {
        rating += '<i class="custom-rating-icon spr-icon spr-icon-star-empty"></i>';
      }
      rating += " (0)";
    } else {
      const reviewCount = item.reviews.substr(item.reviews.indexOf("reviewCount") + 15, 1);
      const slice = item.reviews.slice(item.reviews.indexOf("ratingValue") + 15);
      const ratingValue = slice.substr(0, slice.indexOf('"'));

      if (ratingValue > 4.5) {
        // console.log('5');
        for (let i = 0; i < 5; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star"></i>';
        }
      } else if (ratingValue > 4) {
        // console.log('4.5');
        for (let i = 0; i < 4; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star"></i>';
        }
        rating += '<i class="custom-rating-icon spr-icon spr-icon-star-half-alt"></i>';
      } else if (ratingValue > 3.5) {
        // console.log('4');
        for (let i = 0; i < 4; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star"></i>';
        }
        rating += '<i class="custom-rating-icon spr-icon spr-icon-star-empty"></i>';
      } else if (ratingValue > 3) {
        // console.log('3.5');
        for (let i = 0; i < 3; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star"></i>';
        }
        rating += '<i class="custom-rating-icon spr-icon spr-icon-star-half-alt"></i>';
        for (let i = 0; i < 1; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star-empty"></i>';
        }
      } else if (ratingValue > 2.5) {
        // console.log('3');
        for (let i = 0; i < 3; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star"></i>';
        }
        for (let i = 0; i < 2; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star-empty"></i>';
        }
      } else if (ratingValue > 2) {
        // console.log('2.5');
        for (let i = 0; i < 2; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star"></i>';
        }
        rating += '<i class="custom-rating-icon spr-icon spr-icon-star-half-alt"></i>';
        for (let i = 0; i < 2; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star-empty"></i>';
        }
      } else if (ratingValue > 1.5) {
        // console.log('2');
        for (let i = 0; i < 2; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star"></i>';
        }
        for (let i = 0; i < 3; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star-empty"></i>';
        }
      } else if (ratingValue > 1) {
        // console.log('1.5');
        rating += '<i class="custom-rating-icon spr-icon spr-icon-star"></i>';
        rating += '<i class="custom-rating-icon spr-icon spr-icon-star-half-alt"></i>';
        for (let i = 0; i < 3; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star-empty"></i>';
        }
      } else if (ratingValue > 0.5) {
        // console.log('1');
        rating += '<i class="custom-rating-icon spr-icon spr-icon-star"></i>';
        for (let i = 0; i < 4; i++) {
          rating += '<i class="custom-rating-icon spr-icon spr-icon-star-empty"></i>';
        }
      }

      if (parseInt(reviewCount, 10) > 0) {
        rating += ` (${reviewCount})`;
      }
    }

    // <i class="spr-icon spr-icon-star-empty" style="color: #dfa124;"></i>
    // <i class="spr-icon spr-icon-star" style="color: #dfa124;"></i>
    // <i class="spr-icon spr-icon-star-half-alt" style="color: #dfa124;"></i>

    if (item.isAvailable) {
      if (item.isVaries) {
        price = `<span class="price">from<span class="money">${item.price_min}</span></span>`;
      } else {
        if (item.isSale) {
          price = `<span class="price on-sale">
                      <span class="money">${item.price_min}</span>
                      <span class="original money">${item.original_price}</span>
                    </span>`;
        } else {
          price = `<span class="price money">${item.price_min}</span>`;
        }
      }
    } else {
      price = item.soldout;
    }

    if (item.variant_image_color.length >= 2) {
      if (item.url.indexOf("?") !== -1) {
        withVariableUrl = item.url + "&variant=" + item.variant_image_color[0];
      } else {
        withVariableUrl = item.url + "?variant=" + item.variant_image_color[0];
      }
    }

    console.log(item);

    return `<div class="product-list-item" product-selector="${item.id}">
              <figure class="product-list-item-thumbnail">
                <a href="${withVariableUrl ? withVariableUrl : item.url}">
                    <img
                      src="${item.variant_image_color[1] ? item.variant_image_color[1] : item.image}"
                      alt="${item.title}"
                      data-rimg="noscript"
                      srcset="${item.variant_image_color[1] ? item.variant_image_color[1] : item.image} 1x"
                      class="only-image"
                      loading="lazy"
                    >
                </a>
                ${badge}
              </figure>
                <div class="product-list-item-details">
                  ${brandLink}
                  <h4 class="product-list-item-title"><a href="${item.url}">${item.title}</a></h4>
                  <p class="product-list-item-price">${price}</p>
                  <p>${rating}</p>
                </div>
            </div>
    `;
  }

  return {
    init: init,
    deselectFilter: deselectFilter,
    collectionSearch: collectionSearch,
  };
})();

function productDetail() {
  if (document.querySelector('[data-section-type="page-product"]') === null) {
    return;
  }

  const data = document.querySelector('[data-section-type="page-product"]').textContent;
  const productJSON = JSON.parse(data);
  let sizes = [];
  productJSON.product.variants.forEach((item) => {
    sizes.push(parseFloat(item.option2));
  });

  uniqueSizes = sizes.filter((item, position) => {
    return sizes.indexOf(item) == position;
  });

  const sortedArray = uniqueSizes.sort((a, b) => a - b);

  const refSizes = document.getElementById("product-sizes");
  for (let i = 0; i < sortedArray.length; i++) {
    if (i === 0) {
      refSizes.insertAdjacentHTML("beforeend", productSizeTemplate(sortedArray[i], true));
    } else {
      refSizes.insertAdjacentHTML("beforeend", productSizeTemplate(sortedArray[i]));
    }
  }

  productColorObserver(productJSON);
  productSizeObserver();
}

function productSizeTemplate(value, isActive) {
  return `
    <div class="form-swatch-item ${isActive ? "active" : ""}" data-product-swatch-value="${value}">
      <input 
        type="radio"
        id="${value}" 
        class="form-radio form-swatch-item__input"
        name="option-2"
        data-product-option="option2"
        value="${value}"
      >
      <label class="form-swatch-item__label" for="${value}" aria-label="${value}">${value}</label>
    </div>`;
}

// Color Swatch is created by Swatch app dynamically
// Wait for creating the DOM
function productColorObserver(data) {
  const setIntervalId = setInterval(findTargetElement, 1000);

  function findTargetElement() {
    const colors = document.querySelectorAll("[product-selector] .swatch-item");
    const initialURL = new URL(location);
    const variantParam = initialURL.searchParams.get("variant");
    var activeFound = false;

    if (colors.length > 0) {
      clearInterval(setIntervalId);
      colors.forEach((item) => {
        const variantID = item.parentElement.getAttribute("variant_id");
        let colorName;
        let sizeArray = [];
        let available = false;
        var isActive = false;

        // Get color name from variant id
        for (let i = 0; i < data.product.variants.length; i++) {
          if (data.product.variants[i].id == variantID) {
            colorName = data.product.variants[i].option1;
            break;
          }
        }

        // Get available size from the color
        data.product.variants.forEach((variant) => {
          if (variant.id == variantParam) {
            isActive = true;
            activeFound = true;
          }
          if (variant.option1 == colorName && variant.available === true) {
            sizeArray.push(variant.option2);
          }
        });
        if (!sizeArray.length) {
          $(item.parentElement).hide();
        }
        item.addEventListener("click", (e) => {
          const refSizes = document.getElementById("product-sizes");
          refSizes.querySelectorAll(".form-swatch-item").forEach((element) => {
            if (element.classList.contains("active")) {
              active = true;
              element.classList.remove("active");
            }

            if (sizeArray.indexOf(element.querySelector("input").value) <= -1) {
              element.querySelector("input").disabled = true;
            } else {
              element.querySelector("input").disabled = false;
              if (active) {
                element.classList.add("active");
                active = false;
                element.querySelector("label").click;
              }
            }
          });
        });

        if (isActive) {
          item.click();
        }
      });

      if (!activeFound) {
        var $swatches = $("[product-selector] .collection-color-swatch li:visible .swatch-item");
        if ($swatches.length) {
          $swatches[0].click();
        }
      }
    }
  }
}

function productSizeObserver() {
  let items = [];
  const optionFields = document.getElementsByClassName("js-custom-options");

  if (optionFields.length < 0) {
    return;
  }

  // Divide arrays each options
  // Add Click event listener into each radio buttons
  for (let i = 0; i < optionFields.length; i++) {
    items[i] = optionFields[i].getElementsByClassName("form-swatch-item__label");

    for (let j = 0; j < items[i].length; j++) {
      items[i][j].addEventListener(
        "click",
        function (e) {
          clickObserver(e, i);
        },
        false
      );
    }
  }

  function clickObserver(e, idx) {
    // console.log(e.target.innerHTML);
    // console.log('idx', idx);

    for (let i = 0; i < items[idx].length; i++) {
      items[idx][i].parentElement.classList.remove("active");
    }

    const selectWrapper = document.getElementsByClassName("js-custom-options")[idx];
    const options = selectWrapper.querySelectorAll(".single-option-selector option");

    [].filter.call(options, function (elem) {
      return elem.text === e.target.innerHTML;
    })[0].selected = true;

    e.target.parentElement.classList.add("active");
  }
}

function productReviewToggleObserver() {
  const reviewElement = document.querySelector("#shopify-product-reviews");
  if (!reviewElement) {
    return;
  }

  reviewElement.classList.add("is-hided");

  for (let i = 0; i < reviewElement.children.length; i++) {
    if (reviewElement.children[i].tagName === "SCRIPT") {
      reviewElement.classList.remove("is-hided");
    }
  }
}

function searchObserver() {
  const path = location.pathname;

  if (path === "/collections/all") {
    const crispInstance = theme.Crisp.init();
    search(crispInstance);
    searchFilterObserver(crispInstance);
    filterClearObserver(crispInstance);
  }
}

function search(crispInstance) {
  const params = location.href;
  const splitParams = getParams(params);

  if (splitParams.q && splitParams.filter) {
    theme.Crisp.collectionSearch(
      crispInstance,
      splitParams.q.replace(/\+/g, " "),
      splitParams.filter.replace(/%2C/g, ",")
    );
  } else if (splitParams.q) {
    theme.Crisp.collectionSearch(crispInstance, splitParams.q.replace(/\+/g, " "));
  } else if (splitParams.filter) {
    theme.Crisp.collectionSearch(crispInstance, "", splitParams.filter.replace(/%2C/g, ","));
  } else {
    theme.Crisp.collectionSearch(crispInstance);
  }
}

function filterClearObserver(crispInstance) {
  let URLfilters;
  const filterClearButtons = document.querySelectorAll(".sidebar .filter-menu .filter-group a.filter-clear");

  filterClearButtons.forEach((element) => {
    element.addEventListener("click", (e) => {
      const initialURL = new URL(location);
      e.srcElement.parentElement.querySelectorAll(".collection-container").forEach((item) => {
        if (item.classList.contains("selected")) {
          const tempCheck = initialURL.searchParams.get("filter").indexOf(",");

          if (tempCheck > -1) {
            URLfilters = initialURL.searchParams.get("filter").replace(/%2C/g, ",").split(",");
          } else {
            URLfilters = [initialURL.searchParams.get("filter")];
          }

          const collection = item.querySelector("a").dataset.collection;
          const index = URLfilters.indexOf(collection);
          URLfilters.splice(index, 1);
          item.classList.remove("selected");
          theme.Crisp.deselectFilter(collection);
        }
      });

      const newParams = URLfilters.join(",");
      initialURL.searchParams.set("filter", newParams);
      history.replaceState("", "", initialURL.search);

      e.srcElement.parentElement.querySelector(".menu-trigger").innerHTML =
        e.srcElement.previousSibling.innerHTML;
      e.srcElement.classList.add("hidden");
      search(crispInstance);
    });
  });
}

function searchFilterObserver(crispInstance) {
  const filterElement = document.querySelector(".sidebar .filter-menu");
  const filters = filterElement.querySelectorAll(".collection-container");
  const initialURL = new URL(location);

  filters.forEach((element) => {
    if (initialURL.searchParams.get("filter") !== null && initialURL.searchParams.get("filter") !== "") {
      const filters = initialURL.searchParams.get("filter").replace(/%2C/g, ",").split(",");
      filters.forEach((value) => {
        if (value === element.querySelector("a").dataset.collection) {
          element.classList.add("selected");
          element.parentElement.parentElement.previousSibling.innerHTML =
            element.querySelector("a").dataset.collectionTitle;
          element.parentElement.parentElement.parentElement
            .querySelector("a.filter-clear")
            .classList.remove("hidden");
        }
      });
    }
  });

  filters.forEach((element) => {
    element.querySelector("a").addEventListener("click", (e) => {
      const url = new URL(location);
      if (url.searchParams.get("filter") === null || url.searchParams.get("filter") === "") {
        url.searchParams.set("filter", e.srcElement.dataset.collection);
      } else {
        const filters = url.searchParams.get("filter").replace(/%2C/g, ",").split(",");

        // Check duplicate in the same category
        // If the value exists, it will be replaced the new value
        e.srcElement.parentElement.parentElement.parentElement
          .querySelectorAll(".collection-container")
          .forEach((item) => {
            const index = filters.indexOf(item.querySelector("a").dataset.collection);
            if (index > -1) {
              filters.splice(index, 1);
              item.classList.remove("selected");
              theme.Crisp.deselectFilter(item.querySelector("a").dataset.collection);
            }
          });

        filters.push(e.srcElement.dataset.collection);
        const newParams = filters.join(",");
        url.searchParams.set("filter", newParams);
      }

      history.replaceState("", "", url.search);

      element.classList.add("selected");
      element.parentElement.parentElement.previousSibling.innerHTML = e.srcElement.dataset.collectionTitle;
      element.parentElement.parentElement.parentElement
        .querySelector(".filter-clear")
        .classList.remove("hidden");
      search(crispInstance);
    });
  });
}

/*
function autoAdditionalLinks() {
  let links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].relList.add('noreferrer', 'noopener');
    }
  }
}
*/

function getParams(params) {
  const regex = /[?&]([^=#]+)=([^&#]*)/g;
  const params_obj = {};
  let match;
  while ((match = regex.exec(params))) {
    params_obj[match[1]] = match[2];
  }

  return params_obj;
}

function searchIconHijack() {
  const mainHeader = document.querySelector(".main-header");
  const announcementBar = document.getElementById("shopify-section-pxs-announcement-bar").querySelector("a");
  const searchTrigger = document.querySelectorAll("[data-header-search-button]");

  searchTrigger.forEach((item) => {
    item.addEventListener("click", (e) => {
      // Less than 720px Mobile
      if (window.innerWidth > 720) {
        setTimeout(function () {
          const liveSearch = document.querySelector(".livesearch-form");
          const liveSearchResult = document.querySelector(".livesearch-results");
          const baseHeight = announcementBar.offsetHeight + mainHeader.offsetHeight;
          liveSearch.style.top = baseHeight + "px";
          liveSearchResult.style.paddingTop = liveSearch.offsetHeight + baseHeight + "px";
        }, 350);
      }
    });
  });
}

function searchResultLinkHijack() {
  const element = document.querySelector("[data-livesearch-viewall]");
  element.addEventListener("click", (e) => {
    e.preventDefault();
    const searchInput = document.querySelector(".livesearch-input");
    window.location.href = "/collections/all?q=" + searchInput.value;
  });
}

function notFoundPageLinkHijack() {
  const element = document.querySelector("[data-interactive-not-found]");
  if (element !== null) {
    element.addEventListener("click", (e) => {
      e.preventDefault();
      document.querySelector("[data-header-search-button]").click();
    });
  }
}

function init() {
  productReviewToggleObserver();
  // searchObserver();
  // autoAdditionalLinks();
  // productDetail();
  // searchIconHijack();
  // searchResultLinkHijack();
  // notFoundPageLinkHijack();
}

// search through DOM and find all instances of "color" --> "colour"
function languageFilter() {
  // var targetString = document.getElementsByTagName("strong");
  // var testString = "Color:";
  // var newString = "Colour:";
  // if (targetString[0].innerHTML === testString) {
  //   targetString[0].innerHTML = newString;
  //   console.log('we found it');
  // }
}
window.onload = function () {
  languageFilter();

  var $sliderInstagramOptions = {
    pageDots: false,
    contain: true,
    groupCells: true,
    wrapAround: true,
    prevNextButtons: true,
  };

  setTimeout(function () {
    $(".slider--instagram").flickity($sliderInstagramOptions);
  }, 1000);

  if ($(".swatch-option-name").length) {
    $(".swatch-option-name").each(function () {
      console.log("test");
      console.log($(this).text());
      if ($(this).text() == "Color") {
        $(this).text("Colour");
      }
    });
  }
};

document.addEventListener(
  "DOMContentLoaded",
  (e) => {
    init();
  },
  false
);
